import { cn } from "@suraasa/placebo-ui"
import { DeliveryMode } from "api/resources/learningItems/types"
import PgCTLExecutiveBadge from "assets/OfferLetter/PgCTL/pgctl-executive-badge.webp"
import PgCTLExecutiveText from "assets/OfferLetter/PgCTL/pgctl-executive-text.webp"
import PgCTLProfessionalBadge from "assets/OfferLetter/PgCTL/pgctl-professional-badge.webp"
import PgCTLProfessionalText from "assets/OfferLetter/PgCTL/pgctl-professional-text.webp"
import PgCTLStarterBadge from "assets/OfferLetter/PgCTL/pgctl-starter-badge.webp"
import PgCTLStarterText from "assets/OfferLetter/PgCTL/pgctl-starter-text.webp"
import { getDeliveryMode } from "features/LearningItems/getProductDisplayConfig"

const getLogo = (slug: string) => {
  const deliveryMode = getDeliveryMode(slug)
  switch (deliveryMode) {
    case DeliveryMode.EXECUTIVE:
      return {
        text: PgCTLExecutiveText,
        badge: PgCTLExecutiveBadge,
      }
    case DeliveryMode.PROFESSIONAL:
      return {
        badge: PgCTLProfessionalBadge,
        text: PgCTLProfessionalText,
      }
    case DeliveryMode.STARTER:
      return {
        badge: PgCTLStarterBadge,
        text: PgCTLStarterText,
      }
  }
}
const PgCTLLogoSpinning = ({
  className,
  slug,
}: {
  className?: string
  slug: string
}) => {
  const logoImages = getLogo(slug)
  if (!logoImages) return null
  return (
    <div
      className={cn("relative size-full grid place-items-center", className)}
    >
      <img
        style={{
          animationDuration: "50s",
        }}
        src={logoImages.text}
        alt="text"
        className="absolute left-0 top-0 animate-spin"
        loading="eager"
      />
      <img
        src={logoImages.badge}
        alt="badge"
        className="w-[calc(100%_-_30%)]"
        loading="eager"
      />
    </div>
  )
}

export default PgCTLLogoSpinning
